import HeroSection from './components/HeroSection';
import SolutionsSection from './components/SolutionsSection';
import ResultsSection from './components/ResultsSection';
import CTASection from './components/CTASection';

export default function Services() {
  return (
    <>
      <HeroSection />
      <SolutionsSection />
      <ResultsSection />
      <CTASection />
    </>
  );
}